var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContact24 = function SvgContact24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "contact_24_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".contact_24_svg__st0{fill:#393839}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "contact_24_svg__st0",
    d: "M18 11.4c0 .2.2.5.5.5.2 0 .5-.2.5-.5 0-3.3-2.7-6-6-6-.2 0-.5.2-.5.5 0 .2.2.5.5.5 2.7-.2 5 2.1 5 5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "contact_24_svg__st0",
    d: "M12.2 1.7c-.2 0-.5.2-.5.5 0 .2.2.5.5.5 5.2 0 9.5 4.2 9.5 9.5 0 .2.2.5.5.5.2 0 .5-.2.5-.5-.3-5.9-4.8-10.5-10.5-10.5zM15.6 13.5c-.3 0-.6 0-.9.1l-.2.1-.2.1c-.6.6-1 1.3-1.4 2.3-1-.6-1.9-1.3-2.9-2.1-.9-.9-1.6-1.8-2.1-2.9 1-.3 1.7-.8 2.3-1.4l.2-.1.1-.2c.6-2.2-1.3-5-3.1-6.2l-.2.1H7c-2.3 0-4.8 2.9-4.9 4.9v.2c.3 2.5 2.3 5.8 5.1 8.6 2.9 2.9 6 4.8 8.6 5.1h.2c2.1-.1 4.9-2.6 4.9-4.8v-.2l-.1-.2c-1-1.9-3.4-3.4-5.2-3.4zm.3 7.7c-2.2-.3-5.4-2.1-8.1-4.9-2.7-2.8-4.5-5.9-4.8-8.1 0-1.6 2.3-4.1 4-4.1 1.6.9 3.1 3.5 2.6 5.2-.7.6-1.4 1-2.9 1.5.5 1.3 1.4 2.6 2.6 4 1.3 1.3 2.6 2.2 4 2.6.5-1.5.9-2.2 1.5-2.9.2 0 .5-.1.7-.1 1.6 0 3.8 1.4 4.6 2.7-.1 1.8-2.5 4-4.2 4.1z"
  })));
};
export default SvgContact24;